<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>设置管理->设置访客</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 设置闸机策略 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.deviceNo" placeholder="设备编号"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="deviceNo" label="设备编号" width="130"></el-table-column>
                <el-table-column prop="name" label="被访人名单"  :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="synchroStatus" label="状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.synchroStatus == 0">
                            <span style="color: red;">设备同步失败</span>
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 1">
                            等待与设备同步
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 2 
                            || scope.row.synchroStatus == null">
                            已同步到设备
                        </div>
                        <div v-else-if="scope.row.synchroStatus == 3">
                            <span style="color: red;">正在删除</span>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>

    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue'; 

    export default {
        name:"SetVisitor",
        data(){
            return{
                addVisible:false,
                updateVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deviceNo:"",
                    deptId:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.setVisitorListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deviceNo:this.form.deviceNo,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
            selectable(row){
                return true;
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.setVisitorRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/visitor/SetVisitor.vue